let toastMixin = {
    data() {
        return {}
    },
    methods: {
        successToast(message) {
            this.$message.success(message || "Operation successful");
            // this.$toasted.show(message || "Operation successful", {
            //     theme: "outline",
            //     position: "bottom-center",
            //     type: "success",
            //     icon: "check",
            //     duration: 2000
            // });
        },

        errorToast(message) {
            this.$message.error(message || "Operation fail");
        }
    },

};
export { toastMixin };